import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Movie = (props) => {
    const { t } = useLanguage();
    const { movie, additionalClass, borderStyle, titleColor, titleEffectVignette, titleDropEffectVignette, onClickMovie, onError } = props; // Utiliser titleEffectVignette pour le textShadow
    const [isHovered, setIsHovered] = useState(false); // État pour savoir si la carte est survolée
    const movieFrenzyRating = Number(movie?.movieFrenzyAverageRating);
    const hasMovieFrenzyRating = Number.isFinite(movieFrenzyRating);
    const movieFrenzyRatingsCount = Number(movie?.movieFrenzyRatingsCount || 0);

    const movieFrenzyRatingCountLabel =
        movieFrenzyRatingsCount === 1
            ? t("movie.rating.cardRatingCountOne")
            : t("movie.rating.cardRatingCountOther", { count: movieFrenzyRatingsCount });

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    // Gérer le clic si onClickMovie est fourni
    const handleClick = (e) => {
        if (onClickMovie) {
            e.preventDefault();
            onClickMovie();
        }
    };

    const content = (
        <>
            <img
                src={movie.poster_path
                    ? `https://image.tmdb.org/t/p/original/${movie.poster_path}`
                    : "https://zupimages.net/up/23/13/yd61.jpg"}
                alt={movie.title}
                onError={onError}
            />
            {hasMovieFrenzyRating && (
                <div className="movie__mf-rating-badge">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/newColorLogoMovieFrenzy_01.png`}
                        alt="MovieFrenzy"
                    />
                    <span>{movieFrenzyRating.toFixed(1)}/10</span>
                    <small>
                        {movieFrenzyRatingCountLabel}
                    </small>
                </div>
            )}
            <div className="conteneur">
                {/* Appliquer la couleur du titre en fonction de la bordure et l'ombre textuelle */}
                <li className="titre" style={{
                    color: titleColor,
                    textShadow: titleEffectVignette,  // Appliquer l'effet de texte selon la fête avec textShadow
                    zIndex: isHovered ? 1 : 0,  // Assurez-vous que le texte est au premier plan
                    filter: titleDropEffectVignette, // Appliquer l'effet de chute de texte selon la fête avec filter
                }}>
                    {movie.title}
                </li>
            </div>
        </>
    );

    return (
        <div
            className={`movie ${additionalClass || ''}`}
            style={isHovered && borderStyle ? { border: borderStyle } : undefined}  // Applique la bordure uniquement au survol
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {onClickMovie ? (
                <div onClick={handleClick} style={{ cursor: 'pointer' }}>
                    {content}
                </div>
            ) : (
                <Link to={`/ficheFilm/${movie.id}`}>
                    {content}
                </Link>
            )}
        </div>
    );
};

export default Movie;









